/* services */
import { rei } from "@/services/api"

/* libraries */
import moment from "moment"

class FileUploadService {
  static uploadSofiaRei (fileObj, extraArgs = {}) {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } }
    const formData = new FormData()
    formData.append('file', fileObj.file)
    formData.append('registro_id', fileObj.registro_id)
    formData.append('codigo_perfil_ged', fileObj.codigo_perfil_ged)
    formData.append('cartorio_id', fileObj.cartorio_id)
    formData.append('flag_isento', fileObj.flag_isento ? 1 : 0)

    if (fileObj.data_documento) {
      formData.append('data_documento', moment(fileObj.data_documento,'DD/MM/YYYY').format('YYYY-MM-DD'))
    }

    Object.keys(extraArgs).forEach((key) => { formData.append(key, extraArgs[key]) })
    return rei.post(`upload`, formData, config)
  }
}

export default FileUploadService
